import Mailchimp from './mailchimp.js';
import Stripe from './stripe.js';
import Webhooks from './webhooks.js';
import WordPress from './wordpress.js';
import Zapier from './zapier.js';

// make sure you add fill="currentcolor" to svg that should match the text color

var BrandIcon = {
  Mailchimp: Mailchimp,
  Zapier: Zapier,
  WordPress: WordPress,
  Webhooks: Webhooks,
  Stripe: Stripe
};

export { BrandIcon as default };
//# sourceMappingURL=index.js.map
